import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
// import Alert from "react-bootstrap/Alert";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../common-components/CommonStructured";
import DocsForm from "./DocsForm";
import "../../styles/docs/docs.css";
import { fetchFeaturesDocumentationData } from "../../redux/dashboard-features/featuresSlice";
// import DocsListings from "./DocsListings";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import DocVideos from "./DocVideos";
import FeedbackLogs from "./feature-feedback/FeedbackLogs";
import CmnFilters from "../lead-management/common/CmnFilters";
import WelcomeUser from "../Open-pages/user/WelcomeUser";
import Notifications from "../push-notifications/Notifications";
import StakeholdersMobile from "./StakeholdersMobile";
import ViewDocs from "./ViewDocs";
import { isDev } from "../common-data/Commons";
import DocSidebar from "./new-update-0/DocSidebar";

const DocsLanding = ({
  userInfoData,
  isCustom,
  isIOS,
  // isNotificationDenied,
}) => {
  const dispatch = useDispatch();
  const { featureDocLoading } = useSelector((state) => state.features);

  const [searchParams] = useSearchParams();
  const uid = searchParams.get("uid");

  const isAdmin = userInfoData?.account_type === "admin";
  const isCreator =
    isDev ||
    userInfoData?.email === "mousumi.malik@wtfup.me" ||
    userInfoData?.email === "naresh.kukreti@wtfup.me";
  const isCRUDAllow =
    isDev ||
    userInfoData?.email === "mousumi.malik@wtfup.me" ||
    userInfoData?.email === "naresh.kukreti@wtfup.me" ||
    userInfoData?.email === "naresh.kukreti@wtfgyms.com" ||
    userInfoData?.email === "gaurav.singh@wtfgyms.com" ||
    userInfoData?.email === "vn@wtfgyms.com";

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    accountType: !isAdmin
      ? {
          label: userInfoData?.account_type?.replace(/_/g, " ") || "",
          value: userInfoData?.account_type || "",
        }
      : "",
    selAddedby: "",
    selectedFeature: "",
    isActive: !isCRUDAllow
      ? {
          value: "active",
          label: "Active",
        }
      : "",
    selectedNotifyStatus: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    uid: uid || "",
    feature_relevant_for: allFilters.accountType?.value || "",
    feature_stakeholder: allFilters.selAddedby?.value || "",
    feature_id: allFilters.selectedFeature?.value || "",
    status: allFilters.isActive?.value || "",
    is_notified: allFilters.selectedNotifyStatus?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getAllDocs(filters) {
    dispatch(
      fetchFeaturesDocumentationData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getAllDocs(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      // page: isPage + 1,
      // limit: pageLimit || 10,
      feature_relevant_for: allFilters.accountType?.value || "",
      feature_stakeholder: allFilters.selAddedby?.value || "",
      feature_id: allFilters.selectedFeature?.value || "",
      status: allFilters.isActive?.value || "",
      is_notified: allFilters.selectedNotifyStatus?.value || "",
    }));
  }, [
    // isPage,
    // pageLimit,
    allFilters.accountType,
    allFilters.selAddedby,
    allFilters.selectedFeature,
    allFilters.isActive,
    allFilters.selectedNotifyStatus,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumnsRF = [
    {
      dataField: "relevant_for",
      text: "account type",
      formatter: (_, row) => {
        return (
          <span className="tb-data">{row?.replace(/_/g, " ") || "NA"}</span>
        );
      },
    },
  ];

  const tbColumnsEL = [
    {
      dataField: "link_title",
      text: "title",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.link_title || "NA"}</span>;
      },
    },
    {
      dataField: "link_path",
      text: "link",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data icon"
            style={{ textDecoration: "underline", textTransform: "lowercase" }}
          >
            {row?.link_path ? (
              <a
                className=""
                rel="noreferrer"
                target="_blank"
                href={row.link_path}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-box-arrow-up-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
                  />
                  <path
                    fillRule="evenodd"
                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
                  />
                </svg>
              </a>
            ) : (
              "-"
            )}
          </span>
        );
      },
    },
  ];

  const tbColumnsSH = [
    {
      dataField: "name",
      text: "name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.name || "NA"}

            <small className="lowercase underline">
              <br />
              {row?.mobile || "NA"}
              <br />
              {row?.email || "NA"}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "account_type",
      text: "account type",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.account_type?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Dashboard Documentation And Guidance">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {isCustom && (
          <div className="mt30">
            <WelcomeUser userName={userInfoData?.name} />

            {userInfoData && !isIOS() && (
              <Notifications authData={userInfoData} />
            )}

            {/* {isNotificationDenied === "denied" && (
              <Alert variant={"danger"} className="mt30">
                Notification permission is denied. Unable to display desktop
                notifications.
              </Alert>
            )} */}
          </div>
        )}

        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          {modValues.cardName === "add" || modValues.cardName === "edit" ? (
            <DocsForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              isEdit={modValues.cardName === "edit"}
              closeModal={onCloseModal}
              callFunction={() => getAllDocs(filters)}
            />
          ) : (
            <div
              className={`createNewCTOModalContainer ${
                modValues.cardName === "feature_relevant_for" ||
                modValues.cardName === "feature_external_links" ||
                modValues.cardName === "stakeholders"
                  ? "mod-width-50p"
                  : ""
              }`}
            >
              {modValues.cardName !== "feedback" && (
                <ModalHeadAndClose
                  title={`${
                    modValues.cardName === "feature_documentation"
                      ? modValues.rowData?.feature_doc_name +
                          "/" +
                          modValues.rowData?.feature_name || ""
                      : modValues.cardName?.replace(/_/g, " ")
                  } `}
                  onClose={onCloseModal}
                />
              )}

              {modValues.cardName === "feature_documentation" ? (
                <ViewDocs content={modValues.rowData?.feature_documentation} />
              ) : modValues.cardName === "feature_relevant_for" ? (
                <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
                  <PaymentLinkTable
                    tableData={modValues.rowData?.feature_relevant_for || []}
                    tableColumns={tbColumnsRF}
                  />
                </div>
              ) : modValues.cardName === "feature_external_links" ? (
                <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
                  <PaymentLinkTable
                    tableData={modValues.rowData?.feature_external_links || []}
                    tableColumns={tbColumnsEL}
                  />
                </div>
              ) : modValues.cardName === "stakeholders" ? (
                <>
                  <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30 hideMobile">
                    <PaymentLinkTable
                      tableData={modValues.rowData?.feature_stakeholders || []}
                      tableColumns={tbColumnsSH}
                    />
                  </div>

                  <div className="lead-logs-card-container only-mobile">
                    <StakeholdersMobile
                      tableData={modValues.rowData?.feature_stakeholders || []}
                    />
                  </div>
                </>
              ) : modValues.cardName === "feature_videos" ? (
                <DocVideos
                  feature_videos={modValues.rowData?.feature_videos || []}
                />
              ) : modValues.cardName === "feedback" ? (
                <FeedbackLogs
                  userInfoData={userInfoData}
                  rowData={modValues.rowData}
                  prevOnCloseModal={onCloseModal}
                />
              ) : null}
            </div>
          )}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Dashboard Documentation And Guidance"}
              createBtnTxt={isAdmin ? "+ Add New" : null}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => getAllDocs(filters)}
            />
          </Col>
        </Row>

        {!uid && (
          <Row>
            <Col>
              <CmnFilters
                from={"docs"}
                userInfoData={userInfoData}
                onClickReset={onResetFilters}
                filters={allFilters}
                setFilters={setAllFilters}
                onClickSearch={onClickSearch}
                searchFilterApplied={searchFilterApplied}
                isLoading={featureDocLoading}
                searchPlaceHolder="Search By Feature Name, Document Name..."
              />
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            <DocSidebar
              userInfoData={userInfoData}
              isCRUDAllow={isCRUDAllow}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => getAllDocs(filters)}
              isUid={uid || ""}
            />

            {/* <DocsListings
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => getAllDocs(filters)}
            /> */}

            <div className="mb30"></div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DocsLanding;
